import styled from "styled-components";
import CheckboxField from "./CheckboxField";
import ProductImagesFields from "../CustomInputFields/ProductImagesFields";
import MultiselectField from "./MultiselectField";
import NumberInputField from "./NumberInputField";
import SelectField from "./SelectField";
import TextInputField from "./TextInputField";
import Paper from "@material-ui/core/Paper";
import { Button, createStyles, LinearProgress, Theme, withStyles } from "@material-ui/core";
import ProductExtras from "../CustomInputFields/ProductExtras";
import MultisplitItems from "../CustomInputFields/MultisplitItems";

export const FIELDS: { [key: string]: any } = {
  select: SelectField,
  multiSelect: MultiselectField,
  number: NumberInputField,
  boolean: CheckboxField,
  file: ProductImagesFields,
  text: TextInputField,
  extras: ProductExtras,
  internal_bodies: MultisplitItems,
};

export const BorderLinearProgress = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
    },
    bar: {
      borderRadius: 5,
      backgroundColor: "#1a90ff",
    },
  })
)(LinearProgress);
export const Zone = styled(Paper)`
  margin: 20px 0;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const SubmitButton = styled(Button)`
  margin: 20px 50px;
  span {
    pointer-events: none;
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  margin: 10px 0;
`;

export const TitleContainer = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
`;
